import * as z from "zod";
import { DateFromDateOrIsoStringSchema } from "./date-schema";

const MarketplaceNotificationStatusSchema_ = z.discriminatedUnion("status", [
  z.object({ status: z.literal("complete") }),
  z.object({ status: z.literal("skipped") }),
  z.object({
    status: z.literal("pending"),
    date: DateFromDateOrIsoStringSchema.nullish(),
  }),
  z.object({ status: z.literal("failed"), actionMessage: z.string() }),
]);
export const MarketplaceNotificationStatusSchema: z.ZodType<MarketplaceNotificationStatus> =
  MarketplaceNotificationStatusSchema_;

export type MarketplaceNotificationStatus = z.infer<
  typeof MarketplaceNotificationStatusSchema_
>;

export interface IMarketplaceNotificationStatus extends z.ZodType<MarketplaceNotificationStatus> {}
